import styled from "styled-components";

export const Container = styled.div<{ isStepFour?: boolean }>`
  display: grid;
  grid-template-columns: ${({ isStepFour }) => (isStepFour ? "30% 25%" : "25% 25%")};
  margin-bottom: 55px;
`;
